module.exports = __webpack_public_path__ + "static/media/ceo.e5eb8b60.png";